import React, { Component } from 'react';
import PanelHeader from '@components/PanelHeader/PanelHeader';
import { Bar } from 'react-chartjs-2';

class BarChart extends Component {
  colorGraph() {
    switch (this.props.color) {
      case 2:
        return 'rgb(243, 58, 48)';
      case 1:
        return 'rgb(70, 55, 102)';
      default:
        return 'rgb(0, 98, 43)';
    }
  }

  dashboardPanelChart = {
    data: canvas => {
      const ctx = canvas.getContext('2d');
      const gradient = ctx.createLinearGradient(0, 0, 0, 0);
      return {
        backgroundColor: gradient
      };
    },
    options: {
      barRoundness: 5,
      elements: {
        hoverRadius: 16,
        line: {
          tension: 0
        }
      },
      curvature: 1,
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        }
      },
      maintainAspectRatio: false,
      aspectRatio: 1,
      legend: {
        position: 'bottom',
        fillStyle: '#FFF',
        display: false
      },
      scales: {
        xAxes: [
          {
            gridLines: {
              drawTicks: true,
              display: true,
              color: 'transparent',
              zeroLineColor: 'transparent'
            },
            ticks: {
              beginAtZero: true,
              padding: 0,
              fontColor: '#747474',
              fontSize: 12
            }
          }
        ],
        yAxes: [
          {
            gridLines: {
              drawTicks: false,
              display: true,
              color: '#CCCCCC',
              zeroLineColor: '#000000'
            },
            ticks: {
              padding: 10,
              fontColor: '#747474',
              fontSize: 16
            }
          }
        ]
      }
    }
  };

  render() {
    const data = {
      labels: this.props.label,
      datasets: [
        {
          barThickness: 30,
          categoryPercentage: 1,
          pointBackgroundColor: '#FFFFFF',
          fill: false,
          pointRadius: 5,
          pointBorderWidth: 2,
          pointBorderColor: this.colorGraph(),
          pointHoverBackgroundColor: '#FFFFFF',
          pointHoverBorderColor: '#FFFFFF',
          backgroundColor: this.colorGraph(),
          borderColor: this.colorGraph(),
          data: this.props.data
        }
      ]
    };

    return (
      <div
        style={{
          height: 230
        }}
      >
        <PanelHeader
          width={'100%'}
          height={'100%'}
          size='lg'
          content={<Bar data={data} options={this.dashboardPanelChart.options} />}
        />
      </div>
    );
  }
}

export default BarChart;
